import { type EntityLabel } from '@app/data/settings/permissionTemplates';

/**
 * Interface for filters to validate entity fields
 */
export interface EntityRestrictionFilter {
  [key: string]: {
    validIds: Set<string | number>;
  };
}

/**
 * Filters out restricted fields that don't exist in the validIds set
 * @param entity The entity type (e.g. 'lead', 'activity')
 * @param restrictedFields Array of field IDs to filter
 * @param filters Object containing sets of valid IDs for each entity
 * @returns Filtered array of restricted fields
 */
export const filterRestrictedFields = (
  entity: EntityLabel,
  restrictedFields: string[] | undefined,
  filters?: EntityRestrictionFilter,
): string[] | undefined => {
  if (!restrictedFields?.length || !filters) return restrictedFields;
  const entityKey = entity as string;

  if (filters[entityKey]?.validIds) {
    const { validIds } = filters[entityKey];
    return restrictedFields.filter((field) => validIds.has(field) || validIds.has(String(field)));
  }

  return restrictedFields;
};
